import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=f176aad2&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=f176aad2&prod&scoped=true&lang=css"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=f176aad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f176aad2",
  null
  
)

export default component.exports